export default class FeGrade{
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 年级Id
     */
    public gradeId: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 年级编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 年级名字
     */
    public name: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 年级简称
     */
    public shortName: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 开始时间
     */
    public entryDate: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 排序序号
     */
    public orderSeq: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 毕业日期
     */
    public graduateDate: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 学部Id
     */
    public zoneId: string;
    /**
     * @type {string}
     * @memberof FeGrade
     * @name 学部名称
     */
    public zoneName: string;
    /**
     * @type {boolean}
     * @memberof FeGrade
     * @name 是否是当前届次
     */
    public nowGradeFlag: boolean;
    constructor({
        gradeId = '',
        no = '',
        name = '',
        shortName = '',
        entryDate = '',
        orderSeq = '',
        graduateDate = '',
        zoneId = '',
        nowGradeFlag = false
    } = {}) {
        this.gradeId = gradeId,
        this.no = no,
        this.name = name,
        this.shortName = shortName,
        this.entryDate = entryDate,
        this.orderSeq = orderSeq,
        this.graduateDate = graduateDate,
        this.zoneId = zoneId,
        this.nowGradeFlag = nowGradeFlag
    }
}